import { useState } from "react";

// Custom Hook to manage Image State
const useImageState = () => {
  const [imageDataUrl, setImageDataUrl] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0,
  });
  const [error, setError] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);

  return {
    imageDataUrl,
    setImageDataUrl,
    imageName,
    setImageName,
    imageDimensions,
    setImageDimensions,
    error,
    setError,
    isGenerating,
    setIsGenerating,
  };
};

export default useImageState;
